import React from 'react';
import Slider from 'rc-slider';
import "rc-slider/assets/index.css";

class TriStateSwitch extends React.Component {
	constructor(props) {
		super(props);
		var value = this._getInternalValue(props.value);
		this.state = {
			value: value,
			statusColor: this._getColor(value)
		};
	}

	// Public API
	setValue = (value) => {
		this._update(this._getInternalValue(value));
	}

	getValue = () => {
		return this._returnValue(this.state.value);
	}

	// Events
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt();
	}

	onChange = (value) => {
		this.props.onChange && this.props.onChange(value);
	}

	_returnValue = (value) => {
		if (value === 0)
			return false;
		else if (value === 1)
			return null;
		else
			return true;
	}

	_getInternalValue = (value) => {
		if (value === false)
			return 0;
		else if (value === null)
			return 1;
		else
			return 2;
	}

	_getColor(value) {
		if (value === 0)
			return this.props.leftColor;
		else if (value === 1)
			return "rgb(100, 102, 104)";
		else
			return this.props.rightColor;
	}

	_handleChange = value => {
		this._update(value);
	};


	// Private
	_update = (value) => {
		const me = this;
		var color = this._getColor(value);

		this.setState({ value: value, statusColor: color }, function () {
			me.onDirt();

			// If managed by forms, trigger field change, then change
			var returnValue = this._returnValue(value);
			if (this.props.managed)
				this.props.onFieldChange(returnValue, this.props.name, function () { me.onChange(returnValue); });
			else
				// If not, only trigger this comp change
				this.onChange(returnValue);
		});
	}

	// React lifecycle events
	componentWillReceiveProps(nextProps) {
		var internalValue = this._getInternalValue(nextProps.value);
		if (internalValue !== this.state.value) {
			this.setState({ value: internalValue });
		}
	}

	render() {
		return (
			<div style={{ width: 40, margin: 0, marginTop: 15 }}>
				<Slider
					disabled={this.props.disabled}
					min={0}
					max={2}
					value={this.state.value}
					marks={{
						0: { label: this.props.labelLeft, style: { marginLeft: -10 } },
						1: { label: "Null", style: { marginLeft: 10 } },
						2: { label: this.props.labelRight, style: { marginLeft: 30 } }
					}}
					onChange={this._handleChange}
					railStyle={{
						borderRadius: 30,
						height: 19,
						backgroundColor: this.state.statusColor,
						width: 60
					}}
					handleStyle={{
						height: 18,
						width: 18,
						marginLeft: 10,
						marginRight: -10,
						marginTop: 0,
						backgroundColor: "white",
						border: 1,
						borderColor: "rgb(0, 105, 217)"

					}}
					trackStyle={{
						background: "none"
					}}
				/>
				<p>{this.state.marl}</p>
			</div>
		);
	}
}

export default TriStateSwitch;

TriStateSwitch.defaultProps = {
	formControl: true,
	managed: false,
	labelLeft:"Need",
	labelRight:"Valid",
	leftColor: "rgb(255, 193, 7)",
	rightColor: "rgb(40, 167, 69)",
	disabled: false
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/triStateSwitch/TriStateSwitch.js